(() => {
  const STYLE_ID = 'majbwr-product-standard-styles';

  const normalize = (value = '') => value.replace(/\s+/g, ' ').trim();

  const ensureStyles = () => {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .majbwr-compact-size-guide {
        width: 100%;
        max-width: 100%;
        margin: 12px 0 16px;
        border: 1px solid rgba(201, 168, 76, .28);
        border-radius: 8px;
        background: rgba(255, 255, 255, .025);
        box-sizing: border-box;
        overflow: hidden;
      }

      .majbwr-compact-size-guide > summary {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        min-height: 42px;
        padding: 10px 12px;
        box-sizing: border-box;
        cursor: pointer;
        list-style: none;
        color: inherit;
        font-family: Georgia, 'Times New Roman', serif;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: .14em;
        text-transform: uppercase;
      }

      .majbwr-compact-size-guide > summary::-webkit-details-marker { display: none; }
      .majbwr-compact-size-guide > summary::after {
        content: '+';
        flex: 0 0 auto;
        font-family: Arial, Helvetica, sans-serif;
        font-size: 17px;
        font-weight: 400;
        line-height: 1;
      }
      .majbwr-compact-size-guide[open] > summary::after { content: '−'; }

      .majbwr-compact-size-guide__content {
        max-width: 100%;
        padding: 0 10px 10px;
        box-sizing: border-box;
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
      }

      .majbwr-compact-size-guide__note {
        margin: 0 0 9px;
        color: var(--color-muted, rgba(255,255,255,.62));
        font-size: 11px;
        line-height: 1.45;
      }

      .majbwr-compact-size-guide__content table,
      .majbwr-compact-size-guide__content .sbl-size-table {
        display: table !important;
        width: max-content !important;
        min-width: 100% !important;
        max-width: none !important;
        margin: 0 !important;
        border-collapse: collapse !important;
        table-layout: auto !important;
        background: transparent !important;
      }

      .majbwr-compact-size-guide__content table th,
      .majbwr-compact-size-guide__content table td,
      .majbwr-compact-size-guide__content .sbl-size-table th,
      .majbwr-compact-size-guide__content .sbl-size-table td {
        padding: 6px 7px !important;
        color: inherit !important;
        background: transparent !important;
        border-color: rgba(255,255,255,.12) !important;
        font-size: 11px !important;
        line-height: 1.35 !important;
        white-space: nowrap !important;
        box-sizing: border-box !important;
      }

      .majbwr-compact-size-guide__content img {
        max-width: 100% !important;
        height: auto !important;
      }

      .majbwr-compact-size-guide__sizes {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(54px, 1fr));
        gap: 6px;
        min-width: 0;
      }

      .majbwr-compact-size-guide__size {
        display: grid;
        min-width: 0;
        min-height: 34px;
        place-items: center;
        padding: 6px;
        border: 1px solid rgba(201, 168, 76, .24);
        border-radius: 6px;
        box-sizing: border-box;
        font-size: 11px;
        line-height: 1.2;
        text-align: center;
        overflow-wrap: anywhere;
      }

      .majbwr-product-standard {
        max-width: 100%;
        margin: 28px 0 0;
        padding: 12px 14px;
        border-top: 1px solid rgba(201, 168, 76, .24);
        border-bottom: 1px solid rgba(201, 168, 76, .14);
        box-sizing: border-box;
        color: var(--color-muted, rgba(255,255,255,.66));
        font-size: 11px;
        line-height: 1.5;
      }

      .majbwr-product-standard__row {
        margin: 0;
        overflow-wrap: anywhere;
      }

      .majbwr-product-standard__row + .majbwr-product-standard__row { margin-top: 6px; }
      .majbwr-product-standard strong { color: var(--color-text, inherit); font-weight: 700; }
      .majbwr-product-standard a { color: inherit; text-underline-offset: 2px; }

      @media (max-width: 749px) {
        .majbwr-compact-size-guide { margin: 10px 0 14px; }
        .majbwr-compact-size-guide > summary { min-height: 40px; padding: 9px 10px; font-size: 10px; }
        .majbwr-compact-size-guide__content { padding: 0 8px 8px; }
        .majbwr-compact-size-guide__content table th,
        .majbwr-compact-size-guide__content table td,
        .majbwr-compact-size-guide__content .sbl-size-table th,
        .majbwr-compact-size-guide__content .sbl-size-table td {
          padding: 5px 6px !important;
          font-size: 10px !important;
        }
        .majbwr-compact-size-guide__sizes { grid-template-columns: repeat(auto-fit, minmax(48px, 1fr)); gap: 5px; }
        .majbwr-compact-size-guide__size { min-height: 32px; padding: 5px; font-size: 10px; }
        .majbwr-product-standard { margin-top: 22px; padding: 10px 0; font-size: 10px; line-height: 1.45; }
      }
    `;
    document.head.appendChild(style);
  };

  const getOptionName = (fieldset) => {
    const input = fieldset.querySelector('input[name^="options["]');
    if (!input) return '';
    const match = input.name.match(/^options\[(.*)\]$/);
    return match ? match[1].trim() : '';
  };

  const getValues = (fieldset) => Array.from(fieldset.querySelectorAll('.product-option__chip'))
    .map((label) => normalize(label.textContent))
    .filter(Boolean);

  const isSizeOption = (name) => {
    const value = name.toLowerCase().trim();
    return value.includes('size') || value === 'age' || value === 'ages';
  };

  const isColorOption = (name) => {
    const value = name.toLowerCase().trim();
    return value === 'color' || value === 'colour' || value.includes('color') || value.includes('colour');
  };

  const removeLegacyCompliance = (product) => {
    const description = product.querySelector('.product__description');
    if (!description) return;

    const candidates = Array.from(description.querySelectorAll('p, h2, h3, h4, h5'));

    candidates.forEach((node) => {
      if (!node.isConnected) return;
      const text = normalize(node.textContent);
      const lower = text.toLowerCase();
      if (!lower) return;

      const aiHeading = lower === 'ai disclaimer' || lower === 'ai image disclaimer' || lower === 'ai model disclaimer';
      const aiBlock = lower.startsWith('ai disclaimer') || lower.startsWith('ai image disclaimer') || lower.startsWith('ai model disclaimer') ||
        (text.length < 650 && (lower.includes('ai-generated') || lower.includes('ai generated') || lower.includes('ai-assisted') || lower.includes('ai assisted')) && (lower.includes('image') || lower.includes('model') || lower.includes('visual')));
      const euHeading = lower === 'eu representative' || lower === 'eu representative:' || lower === 'eu responsible person';
      const euBlock = lower.startsWith('eu representative') || lower.startsWith('eu responsible person');
      const productInfoHeading = lower === 'product information' || lower === 'product information:';
      const productInfoBlock = lower.startsWith('product information') && (lower.includes('warranty') || lower.includes('generic brand') || lower.includes('bella+canvas'));

      if (aiHeading || euHeading || productInfoHeading) {
        const next = node.nextElementSibling;
        node.remove();
        if (next && next.matches('p') && normalize(next.textContent).length < 700) next.remove();
        return;
      }

      if (aiBlock || euBlock || productInfoBlock) node.remove();
    });
  };

  const findSupplierGuide = (product) => {
    const description = product.querySelector('.product__description');
    const selectors = [
      '.sbl-size-guide-container',
      'table#size-guide',
      '.sbl-size-table',
      '[class*="size-chart"]',
      '[id*="size-chart"]'
    ];

    if (description) {
      for (const selector of selectors) {
        const match = description.querySelector(selector);
        if (match && !match.closest('[data-majbwr-compact-size-guide]')) return match;
      }
    }

    const customGuide = product.querySelector('.size-guide[id^="SizeGuide-"]');
    if (customGuide && !customGuide.closest('[data-majbwr-compact-size-guide]')) return customGuide;

    return null;
  };

  const getGuideAnchor = (product) => {
    const fieldsets = Array.from(product.querySelectorAll('fieldset.product-option'));
    const color = fieldsets.find((fieldset) => isColorOption(getOptionName(fieldset)));
    if (color) return color;

    const size = fieldsets.find((fieldset) => isSizeOption(getOptionName(fieldset)));
    if (size) return size;

    return fieldsets[fieldsets.length - 1] || null;
  };

  const insertGuide = (product, details) => {
    const anchor = getGuideAnchor(product);
    if (anchor) {
      anchor.insertAdjacentElement('afterend', details);
      return;
    }

    const purchase = product.querySelector('.product__purchase');
    if (purchase) {
      purchase.insertAdjacentElement('beforebegin', details);
      return;
    }

    const form = product.querySelector('.product__form');
    if (form) form.appendChild(details);
  };

  const createGuideShell = () => {
    const details = document.createElement('details');
    details.className = 'majbwr-compact-size-guide';
    details.dataset.majbwrCompactSizeGuide = '';

    const summary = document.createElement('summary');
    summary.textContent = 'SIZE GUIDE';

    const content = document.createElement('div');
    content.className = 'majbwr-compact-size-guide__content';

    details.append(summary, content);
    return { details, content };
  };

  const renderCompactGuide = (product) => {
    if (product.querySelector('[data-majbwr-compact-size-guide]')) return;

    const supplierGuide = findSupplierGuide(product);
    if (supplierGuide) {
      const { details, content } = createGuideShell();
      const note = document.createElement('p');
      note.className = 'majbwr-compact-size-guide__note';
      note.textContent = 'Supplier measurements for this product.';
      content.appendChild(note);
      content.appendChild(supplierGuide);
      insertGuide(product, details);
      return;
    }

    const sizeFieldset = Array.from(product.querySelectorAll('fieldset.product-option'))
      .find((fieldset) => isSizeOption(getOptionName(fieldset)));
    if (!sizeFieldset) return;

    const values = [...new Set(getValues(sizeFieldset))];
    if (!values.length) return;

    const { details, content } = createGuideShell();
    const note = document.createElement('p');
    note.className = 'majbwr-compact-size-guide__note';
    note.textContent = 'Available sizes from this product’s live options. No measurements have been estimated.';

    const grid = document.createElement('div');
    grid.className = 'majbwr-compact-size-guide__sizes';
    grid.setAttribute('role', 'list');

    values.forEach((value) => {
      const item = document.createElement('span');
      item.className = 'majbwr-compact-size-guide__size';
      item.setAttribute('role', 'listitem');
      item.textContent = value;
      grid.appendChild(item);
    });

    content.append(note, grid);
    insertGuide(product, details);
  };

  const renderStandardCompliance = (product) => {
    if (product.querySelector('[data-majbwr-product-standard]')) return;

    removeLegacyCompliance(product);

    const pageWidth = product.querySelector('.page-width');
    if (!pageWidth) return;

    const section = document.createElement('section');
    section.className = 'majbwr-product-standard';
    section.dataset.majbwrProductStandard = '';
    section.setAttribute('aria-label', 'Product notices and EU representative');

    const ai = document.createElement('p');
    ai.className = 'majbwr-product-standard__row';
    ai.innerHTML = '<strong>AI image disclaimer:</strong> Some product imagery may use AI-generated or AI-assisted models, backgrounds or presentation elements. Product details, colours and sizing should be checked against the product information shown on this page.';

    const eu = document.createElement('p');
    eu.className = 'majbwr-product-standard__row';
    eu.innerHTML = '<strong>EU representative:</strong> HONSON VENTURES LIMITED, <a href="mailto:gpsr@honsonventures.com">gpsr@honsonventures.com</a>, 3, Gnaftis House flat 102, Limassol, Mesa Geitonia, 4003, CY';

    const info = document.createElement('p');
    info.className = 'majbwr-product-standard__row';
    info.innerHTML = '<strong>Product information:</strong> Generic brand, 2 year warranty in EU and Northern Ireland as per Directive 1999/44/EC';

    section.append(ai, eu, info);
    pageWidth.appendChild(section);
  };

  const getProducts = (scope) => {
    if (scope.matches?.('[data-product-context]')) return [scope];
    return Array.from(scope.querySelectorAll?.('[data-product-context]') || []);
  };

  const render = (scope = document) => {
    ensureStyles();
    getProducts(scope).forEach((product) => {
      renderCompactGuide(product);
      renderStandardCompliance(product);
    });
  };

  const init = () => render(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('shopify:section:load', (event) => render(event.target));
})();
